import { Stack, Text, Transition } from "@mantine/core";
import { useState } from "react";
import { OffLogo } from "../../shared/OffLogo";
import { StyledActionButton } from "../../shared/StyledActionButton";
import { TimedProgressBar } from "../../shared/TimedProgressBar";

type Props = {
  onNextButtonClick: () => void;
  buttonText?: string;
};

export function PostIdentityTestInfoBreak({ onNextButtonClick, buttonText = "다음" }: Props) {
  const [showButton, setShowButton] = useState(false);

  return (
    <Stack align="center" justify="space-between" gap="xl" h="100%" pb="xl" px="xl">
      <OffLogo />
      <Stack align="center" justify="center" style={{ flexGrow: 1 }}>
        <Text style={{ fontSize: "2rem" }}>🪄</Text>
        <Text ta="center" px="lg">
          “오프의 큐레이터와 알고리즘이 연령, 성별 분포, 취향 테스트를 반영하여 오프닝 테이블을
          만들고 있어요"
        </Text>
      </Stack>

      <Stack h={50} align="center" justify="center" w="100%">
        {!showButton && (
          <TimedProgressBar duration={300} onTimerFinish={() => setShowButton(true)} />
        )}

        <Transition mounted={showButton} transition="fade" duration={400} timingFunction="ease">
          {(styles) => (
            <StyledActionButton style={styles} onClick={onNextButtonClick} w={300}>
              {buttonText}
            </StyledActionButton>
          )}
        </Transition>
      </Stack>
    </Stack>
  );
}
